import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import './Auth.css';

function safeCustomerReturnUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const u = raw.trim();
  if (!u.startsWith('/') || u.startsWith('//')) return null;
  if (!u.startsWith('/customer/')) return null;
  return u;
}

const CustomerLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnParam = searchParams.get('return');
  const returnTo = useMemo(
    () => safeCustomerReturnUrl(returnParam) || '/customer/profile',
    [returnParam]
  );
  const { login, isAuthenticated } = useCustomerAuth();

  useEffect(() => {
    if (isAuthenticated) navigate(returnTo);
  }, [isAuthenticated, navigate, returnTo]);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(formData.email, formData.password);
      navigate(returnTo);
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Sign in to Rainbow Sails</h1>
        <p className="auth-subtitle">Welcome back! Sign in to your account</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <p className="auth-footer">
          Don&apos;t have an account?{' '}
          <Link to={returnParam ? `/customer/signup?return=${encodeURIComponent(returnParam)}` : '/customer/signup'}>
            Create your Rainbow Sails account
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CustomerLogin;

